import { Component } from '@angular/core';

@Component({
  selector: 'prd-products',
  imports: [],
  templateUrl: './products.html',
  styleUrl: './products.scss',
})
export class Products {

}
